module.exports = __webpack_public_path__ + "img/archive.f991dbb7.svg";